import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  CALL_OUT_OF_JURISDICTION,
  CALL_REROUTED,
} from '@rsos/constants/collaborator';
import {
  addCollaborator,
  addLocation,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';

const useHandleCollaboratorMessage = () => {
  const StreamWS = window?.__RSOS?.streamWS?.instance;
  const dispatch = useDispatch();
  const collaboratorMessageTypes = new Set([
    CALL_OUT_OF_JURISDICTION,
    CALL_REROUTED,
  ]);

  const handleCollaboratorMessage = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (message: any) => {
      if (collaboratorMessageTypes.has(message?.type)) {
        const payload = { ...message.body, messageType: message.type };

        // Add collaborator metadata
        dispatch(addCollaborator(payload));

        // For CALL_REROUTED, also add location data to plot marker and draw line
        if (message?.type === CALL_REROUTED && message?.body) {
          const locationPayload = {
            ...message.body,
            // Ensure application starts with 'ali_' for proper secondary location handling
            application:
              message.body.application || 'ali_collaborator_rtt_ingress',
            // class_of_service_category should start with 'Phase' for wireless secondary locations
            class_of_service_category:
              message.body.class_of_service_category || 'Phase1',
            extra_info: {
              ...message.body.extra_info,
              payload_id: message.body.extra_info?.payload_id || '',
              request_id: message.body.extra_info?.request_id || '',
            },
          };
          dispatch(addLocation(locationPayload));
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  useEffect(() => {
    if (StreamWS) {
      StreamWS.addOnMessageCallback({
        handleCollaboratorMessage: handleCollaboratorMessage,
      });

      return () => {
        StreamWS.removeOnMessageCallback('handleCollaboratorMessage');
      };
    }
  }, [StreamWS, handleCollaboratorMessage]);
};

export default useHandleCollaboratorMessage;
